import React, { createContext, useContext, useState, ReactNode } from "react";

// Loading context types
export interface LoadingContextType {
  isLoading: boolean;
  loadingMessage: string;
  showLoader: (message?: string) => void;
  hideLoader: () => void;
}

export interface LoadingProviderProps {
  children: ReactNode;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>("");

  const showLoader = (message: string = ""): void => {
    setLoadingMessage(message);
    setIsLoading(true);
  };

  const hideLoader = (): void => {
    setIsLoading(false);
    setLoadingMessage("");
  };

  const contextValue: LoadingContextType = {
    isLoading,
    loadingMessage,
    showLoader,
    hideLoader,
  };

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};